<template>
  <v-container pa-0 fill-height v-if="data">
    <v-row no-gutters justify="center" align="center" class="fill-height">
      <v-col cols="auto">
        <div class="display-2 white--text font-weight-light mb-6">
          {{ direction === 'down' ? 'Countdown Timer' : 'Stopwatch' }}
        </div>
        <v-row no-gutters justify="center">
          <v-col cols="auto">
            <v-select
                solo
                label="Hours"
                style="width: 250px;"
                hide-details
                class="rounded-lg"
                :items="data.hours"
                :menu-props="{ nudgeBottom: 52, rounded: 'lg' }"
                v-model="details.hours"
                @input="updateTotal($event * 1000)"
            ></v-select>
          </v-col>
          <v-col cols="auto" class="px-3">
            <v-select
                solo
                label="Minutes"
                style="width: 250px;"
                hide-details
                class="rounded-lg"
                :items="data.minutes"
                :menu-props="{ nudgeBottom: 52, rounded: 'lg' }"
                v-model="details.minutes"
                @input="updateTotal($event * 60000)"
            ></v-select>
          </v-col>
          <v-col cols="auto">
            <v-select
                solo
                label="Seconds"
                style=" width: 250px;"
                hide-details
                class="rounded-lg"
                :items="data.seconds"
                :menu-props="{ nudgeBottom: 52, rounded: 'lg' }"
                v-model="details.seconds"
                @input="updateTotal($event * 3600000)"
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters justify="end" class="mt-6">
          <v-btn
              outlined
              class="rounded-lg"
              color="white"
              :dark="!canGoToTimer"
              :disabled="!canGoToTimer"
              @click="goToTimer()"
          >Start The Timer
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TimerDetails",
  props: {
    direction: {
      type: String,
      default: 'down',
    },
  },
  computed: {
    canGoToTimer() {
      return this.total > 0;
    },
  },
  data: () => ({
    data: null,
    details: {
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
    total: 0,
  }),
  methods: {
    goToTimer() {
      this.$emit('next', this.details);
    },
    updateTotal(milliseconds = 0) {
      this.total += milliseconds;
    },
  },
  mounted() {
    this.data = require('@/assets/text/general_tools_timer.json');
  },
}
</script>

<style scoped>

</style>